import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { CourierVehicle } from '../../couriers/courierVehicle';
import { BundleJson } from '../../../types/bundleTypes';
import {
  getBundleColor,
  getBundleFontColor,
  moveOrdersToSelectedBundle,
} from '../utils/bundleDraft';
import './MovingOrdersToBundleModalContent.scss';
import PlannerBundle from './PlannerBundle';

interface Props {
  bundleList: BundleJson[];
  onSelectBundle: (id: string) => void;
  selectedBundle: string;
}

const alertAboutMovingOrdersBetweenBundles = (
  orderIds: string[],
  bundleIdFrom: string,
  bundleIdTo: string
) =>
  Swal.fire({
    title: 'Moving orders between bundles',
    text: `Selected orders ${orderIds.join(
      ', '
    )} will be moved from bundle ${bundleIdFrom} to bundle ${bundleIdTo}`,
    icon: 'warning',
    showCancelButton: true,
    allowOutsideClick: false,
    confirmButtonText: 'Ok',
    confirmButtonColor: '#d33',
  });

export const onTriggerMoveOrdersToSelectedBundle = async (
  bundleIdMoveFrom: string,
  selectedBundleToMoveOrders: string,
  currentBundle: PlannerBundle | null,
  selectedOrders?: string[]
): Promise<Response | boolean> => {
  const selectedOrdersToMove =
    selectedOrders || currentBundle!.state.selectedOrders;
  const isUserAuthorizedMove = await alertAboutMovingOrdersBetweenBundles(
    selectedOrdersToMove,
    bundleIdMoveFrom,
    selectedBundleToMoveOrders
  );
  if (isUserAuthorizedMove.isConfirmed) {
    return moveOrdersToSelectedBundle(
      bundleIdMoveFrom,
      selectedBundleToMoveOrders,
      selectedOrdersToMove
    );
  }
  return false;
};

const MovingOrdersToBundleModalContent = (props: Props) => {
  const { bundleList, onSelectBundle, selectedBundle } = props;
  const [inputValue, changeInputValue] = useState<string>('');
  const filteredBundleList = inputValue
    ? bundleList.filter(
        bundle =>
          bundle.id.includes(inputValue) ||
          bundle.assignedCourierName
            ?.toLowerCase()
            .includes(inputValue.toLowerCase())
      )
    : bundleList;
  return (
    <div className="moving-orders-modal-content-container">
      <div className="search-bar">
        <h2>Move to bundle</h2>
        <input
          autoFocus
          type="text"
          placeholder="Search..."
          value={inputValue}
          onChange={event => changeInputValue(event.target.value)}
        />
      </div>
      <div className="moving-orders-bundle-list">
        {filteredBundleList.map(bundle => {
          const color = getBundleFontColor(bundle.id);
          const backgroundColor = getBundleColor(bundle.id);
          return (
            <div
              key={bundle.id}
              className="moving-orders-plate"
              onClick={() => onSelectBundle(bundle.id)}
            >
              <div
                style={{ backgroundColor: backgroundColor }}
                className="plate-id-background"
              >
                <input
                  id={`bundleTitle${bundle.id}`}
                  type="radio"
                  checked={selectedBundle === bundle.id}
                  onChange={event => onSelectBundle(bundle.id)}
                />
                <div>
                  <span style={{ color }}>{bundle.id}</span>
                </div>
              </div>
              {bundle.assignedCourierId ? (
                <div className="plate-courier-info tooltip">
                  <p className="tooltiptext">{bundle.assignedCourierName}</p>
                  <div className="text-ellipsis-wrapper">
                    <span>
                      <CourierVehicle
                        courier={{
                          travelMode: bundle.travelMode,
                          carType: bundle.carType,
                        }}
                      />{' '}
                      {bundle.assignedCourierName}
                    </span>
                  </div>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MovingOrdersToBundleModalContent;
